package com.patronat.top.core.domain.models.profiles

import com.patronat.top.dto.UserRole
import com.patronat.top.dto.UserStatus

data class UserFilter(
    val query: String? = null,
    val roles: List<UserRole>? = null,
    val statuses: List<UserStatus>? = null,
    val page: Int = 1,
    val pageSize: Int = 20,
    val ownerId: String? = null
)